module.exports = __webpack_public_path__ + "img/shopping-bag(9).bd597922.png";